import { render } from "./ConfigCheckbox.vue?vue&type=template&id=1e107d44&ts=true"
import script from "./ConfigCheckbox.vue?vue&type=script&lang=ts"
export * from "./ConfigCheckbox.vue?vue&type=script&lang=ts"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__